import { ApolloClient, ApolloLink, InMemoryCache, NormalizedCacheObject, Observable } from '@apollo/client'
import { resolveOperation } from './fixtures'

// An Apollo link that resolves every operation from local fixtures instead of
// hitting the network, with a small delay to mimic latency.
const mockLink = new ApolloLink((operation) =>
    new Observable((observer) => {
        const data = resolveOperation(operation.operationName, operation.variables)
        const timer = setTimeout(() => {
            observer.next({ data })
            observer.complete()
        }, 200)
        return () => clearTimeout(timer)
    })
)

export function createMockApolloClient(): ApolloClient<NormalizedCacheObject> {
    return new ApolloClient({ link: mockLink, cache: new InMemoryCache() })
}
